import { render, staticRenderFns } from "./AccordianContainer.vue?vue&type=template&id=27aa43a0&scoped=true"
import script from "./AccordianContainer.vue?vue&type=script&lang=js"
export * from "./AccordianContainer.vue?vue&type=script&lang=js"
import style0 from "./AccordianContainer.vue?vue&type=style&index=0&id=27aa43a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aa43a0",
  null
  
)

export default component.exports